module.exports = __webpack_public_path__ + "assets/img/word-article-wrong.13fd7852.png";